const colors = {
  primary: '#26376D',
  secondary: '#F9DB4A',
  black: '#121212',
  darkGray: '#4D4D4F',
  gray: '#686868',
  lightGray: '#CBCBCB',
  accessibleLightGray: '#AAA',
  accessibleGray: '#707070',
  gray1: '#4D4D4F',
  gray2: '#333333',
  gray3: '#686868',
  gray4: '#DADADA',
  background: '#FAFAFA',
  white: '#FFFFFF',
  pictureBackground: '#EEEEEE',
  tag: '#E7E7E7',
  error: '#EC4040',
  success: '#58A44C',
}

export default colors
